<template>
  <router-view id="app" />
</template>

<script>
import Vue from 'vue'
import i18n from '@/i18n'
import { mapActions, mapGetters } from 'vuex'
import utility from './utilities/utility'
import hotjarLoader from './mixins/hotjar-loader.js'
import rootAccessor from './mixins/root-accessor'

export default {
  name: 'App',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      //title: this.metas.title,
      // all titles will be injected into this template
      //titleTemplate: `%s | ${this.tenantTitle}`,
      titleTemplate: this.metas.title,
      base: { target: '_blank', href: '/' },
      meta: [
          { name: 'description', content: this.metas.description },
          { name: 'twitter:card', content: this.metas.twitterCard },
          { name: 'twitter:site', content: this.metas.twitterAccount },
          { name: 'twitter:title', content: this.metas.title },
          { name: 'twitter:description', content: this.metas.description },
          { name: 'twitter:image', content: this.metas.image },
          { property: 'og:url', content: this.metas.url },
          { property: 'og:title', content: this.metas.title },
          { property: 'og:site_name', content: this.metas.title },
          { property: 'og:description', content: this.metas.description },
          { property: 'og:image', content: this.metas.image },
          { property: 'og:image:width', content: this.metas.imageWidth },
          { property: 'og:image:height', content: this.metas.imageHeight },
          { property: 'og:image:type', content: this.metas.imageType },
      ],
      link: [
        { rel: 'canonical', href: this.metas.url },
      ],
      script: [{
        type: 'application/ld+json',
        json: {
          '@context': 'http://schema.org',
          '@type': this.metas.kind, 
          name: this.metas.title,
          url: this.metas.url,
          logo: this.metas.logo,
        }
      }]
    }
  },
  mixins: [hotjarLoader, rootAccessor],
  computed: {
    ...mapGetters({
      tenantInfo: 'tenantConfig/tenantInfo',
      tenantTitle: "tenantDesign/tenantTitle",
      userToken: 'auth/userToken',
      designConfig: "tenantDesign/config",
      metas: 'meta/all'
    }),
    defaultLanguage () {
      return this.tenantInfo.defaultLanguage
    }
  },
  watch: {
    defaultLanguage: function () {
      i18n.locale = this.defaultLanguage.toLowerCase();
      if(i18n.locale === "en" || i18n.locale === 'hy'|| i18n.locale === 'az' || i18n.locale === 'sk') {
        this.setDirection('ltr')
        this.clearBodyAttribute("data-direction")
      }
    }
  },
  created () {
    this.init().then(response => {
      if(this.userToken){
        this.loadUserSubscriptionStatus()
      }
      // Set portal language, mainly for development
      let locale = utility.getQueryStringValue('locale')
      if (locale) { i18n.locale = locale }
      this.initHotjar()
      if(this.designConfig.general.Skin === 'cloob'){
        document.body.classList.add('gray-purple-theme')
        document.body.classList.add('yekanbakht')
      }
      if(this.designConfig.general.Skin === 'jabe'){
        document.body.classList.add('gray-blue-theme')
        document.body.classList.add('yekanbakht')
      }
      if(this.designConfig.general.Skin === 'sunnyGames'){
        document.body.classList.add('orange-theme')
      }
      if(this.designConfig.general.Skin === 'put'){
        document.body.classList.add('darkred-theme')
      }
    })
  },
  methods: {
    ...mapActions({
      init: 'auth/init',
      setDirection: 'tenantConfig/setDirection',
      loadUserSubscriptionStatus: 'subscription/getUserState'
    })
  }
}
</script>

<style lang="scss">
@import "./sass/main";
</style>
